import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Powers = class Powers extends VuexModule {
    constructor() {
        super(...arguments);
        this.powers = [];
        this.cachedVersion = 0;
    }
    async fetchPowers() {
        const { data: powers, cachedVersion } = await fetchFromCache(this, 'powers', 'power');
        return { powers, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['powers', 'cachedVersion'] })
], Powers.prototype, "fetchPowers", null);
Powers = __decorate([
    Module({ namespaced: true, name: 'powers' })
], Powers);
export default Powers;
